import { createFileRoute } from "@tanstack/react-router";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminCompetitors from "@/pages/admin/AdminCompetitors";
import { adminHead } from "@/lib/route-seo";

export const Route = createFileRoute("/admin/competitors")({
  head: () => adminHead("Competitor Intelligence | Admin", "Competitor analysis dashboard.", "/admin/competitors"),
  component: () => (
    <ProtectedRoute>
      <AdminCompetitors />
    </ProtectedRoute>
  ),
});
